import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import { fromDto as reservationFromDto } from '../../../models/adapters/ReservationAdapter';
import { toDto as specialHourToDto } from '../../../models/adapters/SpecialHourAdapter';
import { addSpecialHour, AddSpecialHourActionType, specialHourAdded, specialHourAddFailed } from '../../actions/setting/addSpecialHour';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* addSpecialHourSaga({ payload }: AddSpecialHourActionType) {
  const { specialHourUuid, specialHour, placeUuid } = payload;
  const token = yield getAuthenticationToken();
  const specialHourDto = specialHourToDto(specialHour);
  const timestamp = moment();
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.addSpecialHour, token, {
    specialHourDto,
    placeUuid,
  });
  if (!response.error) {
    const { affectedReservations: affectedReservationDtos } = response;
    const affectedReservations = (affectedReservationDtos || []).map(reservationFromDto);
    yield put(
      specialHourAdded({
        specialHourUuid,
        specialHour,
        placeUuid,
        timestamp,
        affectedReservations,
      })
    );
  } else {
    yield put(specialHourAddFailed({ placeUuid, specialHourUuid, timestamp }));
  }
}

export default function* watchAddSpecialHourSaga() {
  yield takeEvery(addSpecialHour, addSpecialHourSaga);
}
